<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    v-if="$props.readonly && model"
    class="whitespace-normal"
    v-html="computedHtml"
    />

  <blog-content-edit-wrapper v-else-if="model" v-model="model">
    <ui-wysiwyg
      v-if="!model.is_switching_language"
      v-model="computedContent"
      />
  </blog-content-edit-wrapper>
</template>

<script setup lang="ts">
defineEmits(['remove'])
defineProps<{ readonly?: boolean }>()

const model = defineModel<BlogElement>()
const modelBlog = defineModel<Blog>('blog')
const { locale } = useI18n()

const computedContent = computed({
  get: () => {
    if(!model.value) return ''

    return ((model.value.editing_language ?? locale.value) != 'en')
      ? model.value.meta.i18n[model.value.editing_language ?? locale.value]?.content
      : model.value.content
  },
  set: (value) => {
    if(!model.value) return

    if ((model.value.editing_language ?? locale.value) != 'en') {
      model.value.meta.i18n[model.value.editing_language ?? locale.value].content = value
    } else {
      model.value.content = value
    }
  }
})

const computedHtml = computed(() => {
  let htmlString = computedContent.value
    ? computedContent.value
    : model?.value?.content

  if (modelBlog.value?.meta?.linked_words) {
    const linkedWords = modelBlog.value.meta.linked_words as  {
      [key: string]: string
    }

    Object.keys(linkedWords).forEach((word) => {
      const url = linkedWords[word]
      const link = linkString(word, url)
      const link_count_in_dom = document?.querySelectorAll(`[data-component="Blog"] a[data-linkedstring="${word}"]`).length

      if (htmlString?.includes(word) && url && !link_count_in_dom) {
        const regex = new RegExp(`(\\s|[.,;!?()\\[\\]{}'":]|^|>)(${word})(\\s|[.,;!?()\\[\\]{}'":]|$|<)`)
        htmlString = htmlString.replace(regex, link)
      }
    })
  }

  return htmlString
})
</script>
